export const Services = {
   "REPORTS": {
      "path": "https://roldanapireport.azurewebsites.net",
      "method": "GET",
      "descrp": "METHOD TO SET REPORT"
   }
}